<template>
  <div>
    <modal :item="passedItem" :online="data.online" :offlineMsg="offlineMsg"></modal>
    <section class="section-primary pt-75 pb-113 shop-list">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-lg-3 d-none d-md-block">
            <div class="sidebar sticky-top">
              <div class="widgets widget_search">
                <input class="form-control" type="text" placeholder="Search" v-model="searchTerm">
                <button class="search-icon">
                  <span class="lnr lnr-magnifier"></span>
                </button>
              </div>
              <!-- CATEGORIES -->
              <div class="widgets widget_categories"
                   :style="{ backgroundColor: `${nav_bg === undefined ? '' : nav_bg}`}">
                <scrollactive :modifyUrl="false" @itemchanged="onCategoryItemChanged">
                  <ul>
                    <li
                      v-for="(c, index) in data.categories"
                      :key="index"
                      :class="{ 'is-active': isCategoryActive(c) }"
                    >
                      <a
                        :href="'#'+slugify(c.title)"
                        class="scrollactive-item"
                        @click.prevent="navigateToCategory(c)"
                      >
                        {{ c.title }}
                      </a>
                    </li>
                  </ul>
                </scrollactive>
              </div>
            </div>
          </div>


          <div class="col-md-8 col-lg-9">
            <div class="d-block mb-4" v-if="data.menu_pdf_url">
              <a v-bind:href="data.menu_pdf_url" class="au-btn au-btn--hover has-bg extra-long" target="_blank">Download
                Menu</a>
            </div>

            <div class="d-block mb-4 alert alert-warning" v-if="message">
              <p>{{ message }}</p>
            </div>

            <div v-if="Object.keys(data).length === 0">
              <p>Loading... Please wait...</p>
            </div>


            <div class="searchbox d-block d-md-none">
              <input type="text" placeholder="Search" aria-label="Search" v-model="searchTerm">
              <i class="fa fa-search"></i>
            </div>

            <div v-for="(c, index) in data.categories" class="products" :key="index"
                 v-if="filteredCategories.includes(c.id)">

              <section :id="slugify(c.title)" class="row">
                <div class="col-md-12">
                  <h3>{{ c.title }}</h3>
                </div>

                <template v-for="(m, key) in filteredItems">
                  <div
                    v-if="m.cat_id == c.id"
                    class="col-sm-6 col-md-6 col-lg-4"
                    :key="key"
                    :id="itemElementId(m)"
                  >
                    <div class="item">
                      <div class="thumb text-center">
                        <a @click="toggleModal(m)" href="javascript:void(0)"
                           class="woocommerce-LoopProduct-link woocommerce-loop-product__link">
                          <img v-bind:src="m.img_url.large" v-bind:alt="m.title">
                        </a>
                      </div>
                      <div class="info">
                        <h5 class="woocommerce-loop-product__title">
                          <a @click="toggleModal(m)" href="javascript:void(0)">{{ m.title }}</a>
                        </h5>
                        <span class="price">
                          <span class="woocommerce-Price-amount amount">
                            <span class="woocommerce-Price-currencySymbol">$</span>{{ showPrice(m) }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>

                </template>

              </section>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import Modal from './ProductModal.vue';

export default {
  components: {
    'modal': Modal
  },
  props: ['data'],
  data() {
    return {
      searchTerm: '',
      passedItem: '',
      message: '',
      offlineMsg: '',
      price: '',
      extra: 0,
      quantity: 1,
      extraQuantity: [],
      nav_bg: '',
      pendingCategorySlug: null,
      pendingItemSlug: null,
      modalElement: null,
      suppressNextScroll: false,
      openedViaUserClick: false,
      activeCategorySlug: null
    }
  },
  mounted () {
    this.modalElement = $('#my-modal')
    if (this.modalElement && typeof this.modalElement.on === 'function') {
      this.modalElement.on('hidden.bs.modal', this.onModalHidden)
    }
  },
  beforeDestroy () {
    if (this.modalElement && typeof this.modalElement.off === 'function') {
      this.modalElement.off('hidden.bs.modal', this.onModalHidden)
    }
  },
  beforeUpdate: function () {
    this.nav_bg = this.$props.data.colors.nav_bg
    this.message = this.$props.data.messages.caution
    this.offlineMsg = this.$props.data.messages.offline
  },
  computed: {
    filteredItems: function () {
      if (this.$props.data.items === undefined) {
        return [];
      }
      return this.$props.data.items.filter(item => {
        return item.title.toLowerCase().includes(this.searchTerm.toLowerCase())
      })
    },
    filteredCategories: function () {
      return this.filteredItems.map((item) => item.cat_id)
    }
  },
  watch: {
    '$route.params.categorySlug': {
      immediate: true,
      handler (newSlug) {
        const normalizedSlug = this.normalizeSlug(newSlug)
        this.pendingCategorySlug = normalizedSlug
        this.setActiveCategorySlug(normalizedSlug)
        this.tryScrollToPendingCategory()
      }
    },
    '$route.params.itemSlug': {
      immediate: true,
      handler (newSlug) {
        const normalizedSlug = this.normalizeSlug(newSlug)
        this.pendingItemSlug = normalizedSlug

        if (!normalizedSlug) {
          this.closeModalIfOpen()
        }

        this.tryOpenPendingItem()
      }
    },
    'data.categories': {
      immediate: true,
      handler () {
        this.tryScrollToPendingCategory()
        this.tryOpenPendingItem()
      }
    },
    'data.items': {
      immediate: true,
      handler () {
        this.tryOpenPendingItem()
      }
    }
  },
  methods: {
    showPrice: function (item) {
      if (item.price > 0) {
        return item.price
      } else if (item.min_price == item.max_price) {
        return item.min_price
      } else if (item.min_price == null || item.min_price == 0) {
        return item.max_price
      } else if (item.max_price == null || item.max_price == 0) {
        return item.min_price
      } else {
        return item.min_price + '-' + item.max_price
      }
    },
    toggleModal: function (item, options = {}) {
      const settings = Object.assign({ updateRoute: true }, options)
      this.passedItem = item;
      $("#my-modal").modal('show');
      this.updateRouteForItem(item, settings);
    },
    normalizeSlug (value) {
      return typeof value === 'string' ? value.toLowerCase() : null
    },
    slugify (value) {
      return value
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '')
    },
    setActiveCategorySlug (slug) {
      this.activeCategorySlug = slug || null
    },
    isCategoryActive (category) {
      if (!category || !category.title) {
        return false
      }
      return this.activeCategorySlug === this.slugify(category.title)
    },
    itemSlug (item) {
      return item && item.title ? this.slugify(item.title) : null
    },
    itemElementId (item) {
      return this.itemElementIdFromSlug(this.itemSlug(item))
    },
    itemElementIdFromSlug (slug) {
      return slug ? `item-${slug}` : null
    },
    navigateToCategory (category) {
      const slug = this.slugify(category.title)
      const targetPath = `/${slug}`
      this.pendingCategorySlug = slug
      this.pendingItemSlug = null
      this.setActiveCategorySlug(slug)

      if (this.$route.path === targetPath) {
        this.tryScrollToPendingCategory(true)
        return
      }

      this.$router.push(targetPath)
        .then(() => {
          this.tryScrollToPendingCategory(true)
        })
        .catch((error) => {
          if (!error || error.name !== 'NavigationDuplicated') {
            throw error
          }
          this.tryScrollToPendingCategory(true)
        })
    },
    tryScrollToPendingCategory (force = false) {
      const slug = this.pendingCategorySlug

      if (!slug) {
        return
      }

      if (this.pendingItemSlug && !force) {
        this.suppressNextScroll = false
        return
      }

      if (this.suppressNextScroll) {
        this.suppressNextScroll = false
        return
      }

      if (!Array.isArray(this.data.categories) || !this.data.categories.length) {
        return
      }

      const categoryExists = this.data.categories.some(
        (category) => this.slugify(category.title) === slug
      )

      if (!categoryExists && !force) {
        return
      }

      this.$nextTick(() => {
        if (this.scrollToCategory(slug)) {
          this.setActiveCategorySlug(slug)
          this.pendingCategorySlug = null
        }
      })
    },
    tryOpenPendingItem () {
      const itemSlug = this.pendingItemSlug

      if (!itemSlug) {
        return
      }

      if (!Array.isArray(this.data.items) || !this.data.items.length) {
        return
      }

      const item = this.data.items.find(
        (menuItem) => this.slugify(menuItem.title) === itemSlug
      )

      if (!item) {
        return
      }

      const category = Array.isArray(this.data.categories)
        ? this.data.categories.find(cat => cat.id === item.cat_id)
        : null

      if (category) {
        const categorySlug = this.slugify(category.title)
        if (this.pendingCategorySlug !== categorySlug) {
          this.pendingCategorySlug = categorySlug
          this.tryScrollToPendingCategory(true)
        }
        this.setActiveCategorySlug(categorySlug)
      }

      this.$nextTick(() => {
        if (!this.openedViaUserClick) {
          this.scrollToItem(item)
        }
        this.toggleModal(item, { updateRoute: false })
        this.pendingItemSlug = null
        this.pendingCategorySlug = null
        this.openedViaUserClick = false
      })
    },
    updateRouteForItem (item, options = {}) {
      const settings = Object.assign({ updateRoute: true }, options)
      if (!settings.updateRoute) {
        return
      }

      if (!Array.isArray(this.data.categories)) {
        return
      }

      const category = this.data.categories.find((cat) => cat.id === item.cat_id)

      if (!category) {
        return
      }

      const categorySlug = this.slugify(category.title)
      const itemSlug = this.slugify(item.title)
      const targetPath = `/${categorySlug}/${itemSlug}`

      this.pendingCategorySlug = categorySlug
      this.pendingItemSlug = itemSlug
      this.setActiveCategorySlug(categorySlug)

      if (this.$route.path === targetPath) {
        this.openedViaUserClick = true
        return
      }

      this.openedViaUserClick = true
      this.suppressNextScroll = true

      this.$router.push(targetPath)
        .catch((error) => {
          if (!error || error.name !== 'NavigationDuplicated') {
            throw error
          }
          this.suppressNextScroll = false
        })
    },
    scrollToCategory (slug) {
      if (!slug) {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        return true
      }

      const target = document.getElementById(slug)

      if (!target) {
        return false
      }

      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      return true
    },
    onCategoryItemChanged (event, currentItem) {
      if (!currentItem || !currentItem.hash) {
        return
      }

      const slug = this.normalizeSlug(currentItem.hash.replace('#', ''))
      this.setActiveCategorySlug(slug)
    },
    scrollToItemSlug (slug) {
      const elementId = this.itemElementIdFromSlug(slug)

      if (!elementId) {
        return false
      }

      const target = document.getElementById(elementId)

      if (!target) {
        return false
      }

      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      return true
    },
    scrollToItem (item) {
      return this.scrollToItemSlug(this.itemSlug(item))
    },
    onModalHidden () {
      const { categorySlug, itemSlug } = this.$route.params

      if (!itemSlug) {
        return
      }

      this.pendingItemSlug = null

      const targetPath = categorySlug ? `/${categorySlug}` : '/'

      this.suppressNextScroll = true

      this.$router.replace(targetPath).catch((error) => {
        if (!error || error.name !== 'NavigationDuplicated') {
          throw error
        }
        this.suppressNextScroll = false
      })
    },
    closeModalIfOpen () {
      const modal = document.getElementById('my-modal')
      if (!modal) {
        return
      }

      if (modal.classList.contains('show')) {
        this.openedViaUserClick = false
        $('#my-modal').modal('hide')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Menu.vue